export const uniqueId = (prefix?: string) => {
  prefix = prefix ? prefix + '-' : ''
  const cryptoCompat = window.crypto || (window as any).msCrypto as Crypto
  return prefix + (`${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`).replace(/[018]/g, c =>
    // tslint:disable: no-bitwise
    // tslint:disable: radix
    (parseInt(c) ^ cryptoCompat.getRandomValues(new Uint8Array(1))[0] & 15 >> parseInt(c) / 4).toString(16)
  )
}